import { render, staticRenderFns } from "./StandingOrderDetails.vue?vue&type=template&id=26acf8fa"
import script from "./StandingOrderDetails.vue?vue&type=script&lang=js"
export * from "./StandingOrderDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports